<template>
  <div class="main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">申请时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">提现状态</span>
        <Select v-model="searchParams.status" clearable transfer>
          <Option value="0">{{ userInfo.merchantNo == '260580000000800' ? '待打款' : '申请中' }}</Option>
          <Option value="1">提现成功</Option>
          <Option value="2">已驳回</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
      </div>
    </div>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="resource">
          <div class="detail">
            <span class="table-btn" v-if="(row.detail != '[]' || row.receipt) && row.detail" @click="showResource(row)">查看</span>
            <span class="table-btn" v-if="(row.detail != '[]' || row.receipt) && row.detail" @click="loadDta(row.id)">下载</span>
            <span v-else>无</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="status">
          <div class="tag">
            <span v-if="userInfo.merchantNo != '260580000000800' && row.status == '0'" class="item not-started">申请中</span>
            <span v-if="userInfo.merchantNo == '260580000000800' && (row.status == '-1' || row.status == '0' || row.status == '9')" class="item not-started"
              >待打款</span
            >
            <span v-else-if="row.status == '1'" class="item success">提现成功</span>
            <span v-else-if="row.status == '2'" class="item ended">已驳回</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="toDetail(row.userId, row.id)">明细</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center; margin-top: 20px" />
    </div>
    <!-- 提现结算单弹窗组件 -->
    <withdrawalLot ref="withdrawalLot" />

    <!-- 提现资料查看弹窗组件 -->
    <withdrawalMaterial ref="withdrawalMaterial" />
  </div>
</template>

<script>
import withdrawalLot from './components/withdrawalLot';
import withdrawalMaterial from './components/withdrawalMaterial';
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import Upload from '@/components/commons/Upload/index';

export default {
  mixins: [pageTool, common],
  components: { withdrawalLot, Upload, withdrawalMaterial },
  data() {
    return {
      // 查询参数
      searchParams: {
        date: []
      },
      // 用户信息
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      // 下载链接列表
      urlList: [],
      // 业务员表单
      salesForm: {},
      columns: [
        {
          title: '申请时间',
          key: 'requestTime',
          minWidth: 140,
          align: 'center',
          tooltip: true,
          render(h, params) {
            const time = filter.filterTime(params.row.requestTime, 'YYYY-MM-DD');
            return <span>{time}</span>;
          }
        },
        {
          title: '申请金额',
          key: 'requestAmount',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '提现资料',
          key: 'resource',
          minWidth: 130,
          align: 'center',
          slot: 'resource'
        },
        {
          title: '开户行',
          key: 'bank',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '银行卡号',
          key: 'cardNo',
          minWidth: 220,
          align: 'center'
        },
        {
          title: '状态',
          minWidth: 120,
          align: 'center',
          slot: 'status'
        },
        {
          title: '打款日期',
          key: 'paymentTime',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            const paymentTime = params.row.paymentTime;
            return <span>{paymentTime ? filter.filterTime(paymentTime, 'YYYY-MM-DD') : ''}</span>;
          }
        },
        {
          title: '备注',
          tooltip: true,
          key: 'remark',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 120,
          fixed: 'right',
          align: 'center'
        }
      ]
    };
  },
  activated() {
    this.searchAjax(false);
  },
  created() {
    this.searchAjax();
  },
  methods: {
    searchAjax(isLoad = true) {
      isLoad ? this.pageNum = 1 : '';
      this.getList();
    },
    async getList() {
      try {
        this.listLoading = true;
        // 深拷贝 searchParams，避免直接修改原对象
        let data = JSON.parse(JSON.stringify(this.searchParams));
        // 处理申请时间
        if (Array.isArray(data.date) && data.date.length === 2) {
          data.startTime = data.date[0];
          data.endTime = data.date[1];
        }
        delete data.date;

        const res = await this.$http({
          url: '/buz/userCashWithdrawLog/read/listWithSelf',
          type: 'POST',
          data: {
            pageNo: this.pageNum,
            pageSize: this.pageSize,
            ...data
          }
        });

        this.tableData = res.data || [];
        this.total = res.total || 0;
      } catch (e) {
        // 可以根据需要添加错误提示
        // this.$notice.error('获取列表失败');
      } finally {
        this.listLoading = false;
      }
    },

    // 查看
    showResource(item) {
      try {
        const detail = JSON.parse(item.detail || '[]');
        if (Array.isArray(detail) && detail.length === 1 && detail[0].path) {
          window.open(detail[0].path, '_blank');
        } else {
          this.$refs.withdrawalMaterial.open(item);
        }
      } catch (e) {
        this.$notice.error('资料格式有误，无法查看');
      }
    },

    // 下载
    async loadDta(id) {
      await this.$units.downloadFile('/buz/userCashWithdrawLog/downloadZip', { id: id });
    },

    // 明细
    toDetail(userId, id) {
      this.$refs.withdrawalLot.open(userId, id);
    },

    // 分页
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  width: 100%;
  display: flex;
  justify-content: center;
  .item {
    min-width: 70px;
    padding: 0 7px;
    height: 24px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding-top: 1px;
  }
  .not-started {
    color: #238fff;
    background: #ebf5ff;
    border: 1px solid #b5daff;
  }
  .success {
    width: 72px;
    color: #35bf3f;
    background: #f6fcf4;
    border: 1px solid #abeaae;
  }
  .processing {
    color: #ff8900;
    background: #fff4e8;
    border: 1px solid #ffd4a5;
  }
  .ended {
    color: #e3461f;
    background: #fff5f2;
    border: 1px solid #ffc1b2;
  }
}
</style>
